
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

import Skeleton from '@xt/www/components/skeleton/index.vue'

import ItemSkeleton from '../Item/Skeleton.vue'

@Observer
@Component({
  components: { ItemSkeleton, Skeleton }
})
export default class SettingsGroup extends Vue {
  @Prop({ default: 1 }) skeletonCount: number
  @Prop({ default: true }) isReady: boolean
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
